<template>
<div class="containerbox home">
  <!-- <div
      class="containerbox home"
      :style="{ height: pageHeight + 'px' }"
    > -->
      <div class="tj">
        <!-- <h3>{{this.notesign}}</h3> -->
        <h3>{{this.notesign}}</h3>
        <div class="item zdtj">
          <span>终端统计</span>
          <div>
            <van-row>
              <van-col span="9">安装线路: {{this.dtuCountList.mlCount}}</van-col>
              <van-col span="10" offset="1">终端总数: {{this.dtuCountList.dtuCount}}</van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <div class="chart" id="chart1"></div>
              </van-col>
              <!-- <van-col span="8">
              <div class="chart">架空型</div>
            </van-col>
            <van-col span="8">
              <div class="chart">电缆型</div>
            </van-col> -->
            </van-row>
          </div>
        </div>

        <div class="item zdtj">
          <span>故障情况<em>累计故障总数：{{this.MonthDiaresList.count}}</em></span>
          <div>
            <van-row>
              <van-col span="24">
                <div class="chart maxchart" id="chart2"></div>
              </van-col>
            </van-row>
          </div>
        </div>

        <div class="item zdtj">
          <span>故障类型</span>
          <div>
            <van-row>
              <van-col span="24">
                <div class="chart" id="chart3"></div>
              </van-col>
            </van-row>
            <ul class="gzType" style="margin-top:10px;">
              <li :class="selectindex==Item.type? 'on' : ''" v-for="(Item, index) in selectList" :key="index" @click="select(Item.type)">
                <span>{{Item.lable}}</span>
              </li>
            </ul>
            <!-- <van-row gutter="20" type="flex" justify="center">
              <van-col span="6">
                <van-button round size="small" type="default">近半年</van-button>
              </van-col>
              <van-col span="6">
                <van-button round size="small" type="info">近一年</van-button>
              </van-col>
              <van-col span="6">
                <van-button round size="small" type="default">近三年</van-button>
              </van-col>
              <van-col span="6">
                <van-button round size="small" type="default">全部</van-button>
              </van-col>
            </van-row>-->
          </div>
        </div>

        <div class="item xltj">
          <span>线路故障统计<em>监测线路总数：{{MlineDiaresList.total}}</em></span>
          <ul >
            <li v-for="(item, index) in MlineDiaresList.listMLName" :key="index" v-show = "index<3" @click="mlineHistoryDiares(index)">
              <div class="xltit"><i :style="{background:bcolor[index]}">{{index+1}}</i><span>{{MlineDiaresList.listMLName[index]}}</span></div>
              <div>
                <div class="progress">
                  <div class="progress-bar" :style="{width:MlineDiaresList.listbfb[index] + '%'}"></div>
                </div>
                <span class="num">{{MlineDiaresList.listCount[index]}}</span>

              </div>
              <div>
                <span class="itext">接地：{{MlineDiaresList.listjd[index]}}</span>
                <span class="itext">速断：{{MlineDiaresList.listsd[index]}}</span>
                <span class="itext">过流：{{MlineDiaresList.listgl[index]}}</span>
                <span class="itext">瞬时性短路：{{MlineDiaresList.listssxdl[index]}}</span>
              </div>
            </li>
          </ul>
          <a @click="mlineDiares" v-show="MlineDiaresList.total>3">查看更多</a>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Col, Row, Button, Toast } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
import myMixintj from '@/utils/minxinstj.js'
Vue.use(Col, Row, Button, Toast) // 引入混入

export default {
  name: 'tjPage',
  mixins: [myMixintj], // 引入混入
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  watch: {
    // 使用watch 监听$router的变化
    $route (to, from) {
      // console.log(from.name)
      if (from.name === 'login' || from.name === 'guide') {
        if (window.config.type===0){
          this.getXT()// 查询系统
        }
        this.getdtuCount()// 终端统计
        this.getMonthDiares()// 故障情况按月统计
        this.getDiaresType()// 故障类型
        this.getMlineDiares()// 线路故障统计
      }
    }
  },
  created () {
    // console.log('created')
  },
  activated () {
    // console.log('activated')
  },
  mounted () {
    // console.log('mounted')
    if (window.config.type===0){
        this.getXT()// 查询系统
    }
    this.getdtuCount()// 终端统计
    this.getMonthDiares()// 故障情况按月统计
    this.getDiaresType()// 故障类型
    this.getMlineDiares()// 线路故障统计
  },
  methods: {
    getXT () {
      this.util.post('/getXT').then(({ data }) => {
        if (data.code === 200) {
          this.notesign = data.data.notesign
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    mlineDiares () {
      this.$router.replace({
        path: '/mlineDiaresPage'// 跳转到线路故障统计页
      })
      // let newUrl = this.$router.resolve({
      //   path: '/mlineDiaresPage'
      // })
      // window.open(newUrl.href, '_blank')
    },
    mlineHistoryDiares (index) {
      this.$router.push({
        path: '/mlineHistoryDiaresPage', query: { mlineId: this.MlineDiaresList.listMLineId[index] } // 跳转到线路历史故障页
      })
    },
    select (type) {
      // 切换日月周
      if (type === 1) {
        // 点击近半年
        this.selectindex = 1
        this.type = 1
      } else if (type === 2) {
        // 点击近一年
        this.selectindex = 2
        this.type = 2
      } else if (type === 3) {
        // 点击近三年
        this.selectindex = 3
        this.type = 3
      } else {
        // 点击全部
        this.selectindex = 4
        this.type = 4
      }
      this.getDiaresType()
    },
    getdtuCount () {
      // 终端统计
      this.util.post('/dtuCount', {
        timeType: this.type
      }).then(({ data }) => {
        if (data.code === 200) {
          this.dtuCountList = data.data
          // this.util.toast(data.msg)
          this.drawLine_aa()
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getMonthDiares () {
      // 故障情况按月统计
      this.util.post('/getMonthDiares', {
        timeType: this.type
      }).then(({ data }) => {
        if (data.code === 200) {
          this.MonthDiaresList = data.data
          // this.util.toast(data.msg)
          this.drawLine_bb()
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getDiaresType () {
      // console.log('hhhhhhhhhh' + this.type)
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      // 故障类型统计
      this.util.post('/getDiaresType', {
        timeType: this.type// 1:近半年 2：近一年 3：近三年 4：全部
      }).then(({ data }) => {
        if (data.code === 200) {
          this.DiaresTypeList = data.data
          // this.util.toast(data.msg)
          this.drawLine_cc()
          Toast.clear()// 手动清除 Toast
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getMlineDiares () {
      // 线路故障统计
      this.util.post('/getMlineDiares', {
        currentPage: 1,
        pagesize: 3
      }).then(({ data }) => {
        if (data.code === 200) {
          this.MlineDiaresList = data.data
          // this.util.toast(data.msg)
          this.drawLine_cc()
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  },
  computed: {
    bcolor: function () {
      return this.coloritem
    }
    // pwidth: function () {
    //   return this.widthPrent
    // }
  },
  data () {
    return {
      notesign: '【行波定位】', // 系统名称
      coloritem: ['#0B7DEC', '#F2B12F', '#0ED1C4', '#9FCBDC'], // 排序圆标背景色
      widthPrent: [50, 20, 10, 32], // 线路进度条宽度比
      MlineDiaresList: {}, // 线路故障统计返回数据
      dtuCountList: {}, // 终端统计返回数据
      MonthDiaresList: {}, // 故障情况按月统计返回数据
      DiaresTypeList: {}, // 故障类型返回数据
      selectindex: 2, // 默认选中近一年
      type: 2, // 1:近半年 2：近一年 3：近三年 4：全部
      selectList: [
        {
          lable: '近半年',
          type: 1
        },
        {
          lable: '近一年',
          type: 2
        },
        {
          lable: '近三年',
          type: 3
        },
        {
          lable: '全部',
          type: 4
        }

      ],
      pageHeight: window.innerHeight - 50
    }
  }
}
</script>

<style scoped lang="less">
.home{
  // height: calc(100% - 46px);
  height: 100vh;
  padding-bottom: 50px;
}
.tj h3{
  margin-bottom: 10px;
}
.home .item > span{
  margin-bottom: 5px;
}
</style>
